import { InvisiblyApiResponse } from 'src/services/api/api-response.types';

export type InvoiceDownloadResult = {
  ok: boolean;
  url: string | null;
  message: string;
};

export function transformDownloadInvoiceResponse(
  response: InvisiblyApiResponse<string | null>,
): InvoiceDownloadResult {
  return {
    ok: response.status?.status_type === true && Boolean(response.item),
    url: response.item ?? null,
    message: response.status?.status_message ?? '',
  };
}

const DOWNLOAD_ELIGIBLE_STATUSES = new Set(['synced', 'paid', 'overdue']);

export function getInvoiceDownloadDisabledReason(invoice: {
  invoice_status?: string | null;
  ext_invoice_number?: string | number | null;
}): string | null {
  const status = invoice.invoice_status?.toLowerCase();
  if (!status || !DOWNLOAD_ELIGIBLE_STATUSES.has(status)) {
    return 'Download is only available for synced, paid, or overdue invoices.';
  }
  if (invoice.ext_invoice_number == null || String(invoice.ext_invoice_number).trim() === '') {
    return 'No QuickBooks invoice is linked to this record.';
  }
  return null;
}
